import _ from 'lodash';
import React from 'react';

export function getModelVariationsForUPCCode(GBGProduct, UPCCodeRecord) {
  let modelVariations = {};
  const { Variations = [] } = GBGProduct;
  const { VariationLinks = [] } = UPCCodeRecord;
  VariationLinks.forEach((variationLink) => {
    Variations.find((variation) => {
      const { Options = [] } = variation;
      const foundOption = Options.find((option) => {
        return (
          variationLink.VariationLabel == variation.Label &&
          variationLink.VariationOptionValue == option.value &&
          variationLink.VariationOptionLabel == option.label
        );
      });
      if (foundOption) {
        variationLink.variationData = {
          ...variation,
        };
        return true;
      }
    });
    if (variationLink.variationData && !modelVariations[`${variationLink.VariationLabel}###GBGProductVariation`]) {
      modelVariations[`${variationLink.VariationLabel}###GBGProductVariation`] = {
        selectedOptions: [
          {
            label: variationLink.VariationOptionLabel,
            value: variationLink.VariationOptionValue,
          },
        ],
        optionsVisible: true,
        addNewOptionVisible: false,
        value: variationLink.VariationOptionValue,
        label: variationLink.VariationLabel,
        UseInTitle: variationLink.variationData.UseInTitle,
        AddTag: variationLink.variationData.AddTag,
      };
    }
  });
  return modelVariations;
}

export function searchUPCCodes(params = {}) {
  const self = this;
  let queryParams = {
    perPage: 20,
    sortBy: 'GBGProductID.Model:-1',
    lookup: ['GBGProductID'],
    GBGProductIDExists: true,
    GBGProductIDLookupFilters: JSON.stringify([{ $eq: ['$Deleted', false] }, { $eq: ['$Type', 'Public'] }]),
  };

  if (!_.isUndefined(params.page) && params.page !== 1) {
    queryParams.page = params.page;
  }
  if (this.state.screensData.searchUPCText) {
    queryParams.searchText = this.state.screensData.searchUPCText;

    if (_.isUndefined(queryParams.page)) {
      queryParams.sendSearchResultEvent = true;
    }
  }

  return this.props
    .makeRequest(queryParams, {
      endpoint: '/upc_codes',
      timeout: 25023,
      not_display_success_message: true,
    })
    .then((res) => {
      const GBGProductsData = res.data.data
        .filter((item) => {
          return item.GBGProductID;
        })
        .map((item) => {
          return {
            ...item.GBGProductID,
            UPCCodeRecord: {
              UPCCode: item.UPCCode,
              VariationLinks: item.VariationLinks ? item.VariationLinks : [],
            },
          };
        });

      if (res.data.total > 0) {
        self.setScreensData({
          GBGProductsData: GBGProductsData,
          GBGProductsTotal: res.data.total,
          GBGProductsPage: _.get(queryParams, 'page', 1) - 1,
          listingsFetched: false,
          GBGProductsFetched: true,
        });
      } else {
        self.setScreensData({
          GBGProductsTotal: res.data.total,
          GBGProductsPage: _.get(queryParams, 'page', 1) - 1,
          GBGProductsFetched: true,
        });
      }
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

export var searchUPCCodesDebounce = _.debounce(searchUPCCodes, 1000, {
  /* to not trigger startTimeTrackingInterval two times (one of them in willReceiveProps) when user presses on Start button */
  leading: true,
  trailing: true,
});

export function displaySellerAndPickupData() {
  const { SellerID, SellerPickupNumber } = this.state.screensData.currentServiceRecord || {};

  if (!SellerID) {
    return null;
  }

  const marketName = this.state.screensData.ServiceItemMarket || '';
  const { DisplayName } = SellerID;
  return (
    <div>
      <div className="font-size-18">
        <div className="text-bold">{`${DisplayName}.${SellerPickupNumber} ${marketName}`}</div>
      </div>
    </div>
  );
}

